import React, {Component} from "react";
import {validateRequired} from "../../../shared/components/form/ValidationFunctions";
import CustomForm from "../../../shared/components/form/CustomForm";

class FtoCommentsCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {
        fields: {
          category: {
            type: 'select',
            label: 'Phase comments',
            rules: [validateRequired('Phase comments')],
            value: 'value',
            optionLabel: 'label',
            options: [{
              value: 'general',
              label: 'General'
            }, {
              value: 'weekly',
              label: 'Weekly'
            }]
          },

          comment: {
            type: 'textarea',
            label: 'Comments',
            rules: [validateRequired('Comments')],
          },
        }
      },
      initialValues: {
        category: 'general'
      }
    }
  }

  render() {
    return (
      <div>
        <CustomForm
          config={this.state.form}
          submitAction={this.props.saveNoteAction}
          initialValues={this.props.initialValues || this.state.initialValues}
          onSuccess={() => this.props.onSuccess()}
        />
      </div>
    );
  }
}

export default FtoCommentsCreate;
